import React from "react";
import {
  Route,
  Routes as BrowserRoutes,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { ApiProvider } from "src/lib/ApiProvider";
import Poster from "./Poster";

import { Receipt } from "./Receipt/Receipt";
import { ReceiptsList } from "./ReceiptsList";
import { RequestReceiptsForm } from "./ReceiptsForm";
import { DocumentViewer } from "./DocumentViewer";
import { NotFound } from "./NotFound";
import styled from "styled-components";

export const AppRoutes: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const sessionToken = searchParams.get("sessionToken");
  const orderId = searchParams.get("orderId");

  /**
   * We need to handle old routing when the session token was passed as a
   * query parmaters ?sessionToken=''&orderId=''
   */
  React.useEffect(() => {
    if (sessionToken && orderId) {
      navigate(`/receipts/${orderId}/${sessionToken}`);
    }
  }, [navigate, orderId, sessionToken]);

  return (
    <BrowserRoutes>
      <Route
        path="/"
        element={
          <ApiProvider>
            <RequestReceiptsForm />
          </ApiProvider>
        }
      />
      <Route
        path="/list"
        element={
          <ApiProvider>
            <ReceiptsList />
          </ApiProvider>
        }
      />
      <Route
        path="/receipts/:orderId/:sessionToken"
        element={
          <ApiProvider>
            <MaxWidth>
              <Receipt />
            </MaxWidth>
          </ApiProvider>
        }
      />
      <Route
        path="/poster"
        element={<Poster />}
      ></Route>
      <Route
        path="/documents/:documentKey"
        element={<DocumentViewer/>}
      ></Route>
      <Route
        path="*"
        element={<NotFound />}
      />
    </BrowserRoutes>
  );
};

const MaxWidth = styled.div`
  max-width: 900px;
  margin: 0 auto;
`
